import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Diese Seite konnte nicht gefunden werden. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackgroundPattern = _resolveComponent("BackgroundPattern")!
  const _component_SectionSpacerClouds = _resolveComponent("SectionSpacerClouds")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hero-404", `hero__${_ctx.pageType}`])
  }, [
    _createVNode(_component_BackgroundPattern),
    _createElementVNode("div", {
      class: "hero__container",
      style: _normalizeStyle(_ctx.minHeightPx)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.error), 1),
        _hoisted_2
      ])
    ], 4),
    _createVNode(_component_SectionSpacerClouds, {
      ref: "clouds",
      placement: "top",
      class: "mt-0"
    }, null, 512)
  ], 2))
}